import en from './en';
import ch from './ch';
import Cook from "../common/cookie";
export function language () {
    var lan = Cook.get("lang");
    if (lan == null || lan == undefined) {
        Cook.set("lang", "ch", 7)
    }
    if (lan == "en") {
        return en;
    }
    return ch;
}